import { AbstractSensorContentState } from '../../cross-team-shared/state/abstract-sensor-content-state';
import { MouseState } from '../../cross-team-shared/state/mouse-state';
import { RegionOfInterestState } from '../../cross-team-shared/state/region-of-interest-state';
import {
  PointCloudTool,
  UniversalTool,
} from '../../cross-team-shared/tools-names';
import { AssetBoundingBox } from '../../team-apis/3d/task-data/asset-bounding-box';
import { ViewBox } from '../../team-apis/content/view-box';
import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { CalibrationData } from '../../team-apis/otterdam/calibration-data';
import { PointCloudOutput } from '../../team-apis/otterdam/outputs/point-cloud-output';
import { Location } from '../task-data/sensor-location';
import { ObjectWith } from '../utils/misc-utils';
import { CameraState } from './camera-state';
import { EditPanelState } from './edit-panel-state';
import { RenderState } from './render-state';
import { SensorRendererState3D } from './sensor-renderer-state';
import { ViewRegionState } from './view-region-state';

export type PointCloudToolName = UniversalTool | PointCloudTool;

export const X = 0;
export const Y = 1;
export const Z = 2;

export class PointCloudContentState extends AbstractSensorContentState {
  override output!: PointCloudOutput;
  override selectedTool?: PointCloudToolName;

  assetBoundingBox?: AssetBoundingBox;
  calibrationData: ObjectWith<CalibrationData> = {};
  camera = new CameraState([0, 0, 0], [0, 0, 0]);
  editPanel = new EditPanelState();
  locations?: Location[];
  mouse = new MouseState();
  projectionImageSize: StrictRecord<string, Point2D> = {};
  regionOfInterestSettings = new RegionOfInterestState();
  render = new RenderState();
  rescaleAllFrames = false;
  sensorRendererState = new SensorRendererState3D();
  splitViewOutputName?: string;
  viewBoxes: StrictRecord<string, ViewBox> = {};
  viewBoxHighlightEnabled = false;
  viewRegions = new ViewRegionState();
  zoomPanelViewBoxes: StrictRecord<string, ViewBox> = {};
}
